<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.$router.push('/administracion/usuarios/editar/' + this.params.data.id).catch(() => {}) 
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmación de borrado',
        text: `¿Seguro que quiere eliminar al usuario "${this.params.data.username}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar'
      })
    },
    deleteRecord () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      this.$store.dispatch('userManagement/removeUser', this.params.data.id)
        .then(()   => { this.showDeleteSuccess() })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'Usuario eliminado',
        text: 'El usuario seleccionado ha sido eliminado correctamente'
      })
    }
  }
}
</script>
